import { Component, Input, Output } from 'angular-ts-decorators';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
/**
 * A component to expand content at the footer of a document
 *
 * # Example
 * <pre>
 *   <sw-bottom-drawer show-drawer="$ctrl.show" on-change="$ctrl.onChange(value)"></sw-bottom-drawer>
 * </pre>
 */
@Component({
  selector: 'swBottomDrawer',
  template: require('./sw-bottom-drawer.html').default,
  transclude: true,
})
export class SwBottomDrawerComponent {
  @Input() showDrawer: boolean;
  @Input() swColor: string;
  @Output() onChange: (any?) => any;

  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;

  constructor() {
    'ngInject';
  }

  toggleExpand() {
    this.showDrawer = !this.showDrawer;

    this.onChange({ value: this.showDrawer });
  }
}
